export const PhoneFilter = angular
    .module('checkout.filters.vPhone', [])
    .filter('vPhone', () => {
        return (input) => {
            if (input === undefined || input === '') {
                return input;
            }
            input = input.replace(/[^\d]+/g, '');
            var city;
            var number;

            switch (input.length) {
                case 10: // PPP####### -> (PPP) ###-####
                    city = input.slice(0, 3);
                    number = input.slice(3);
                    break;

                default:
                    return input;
            }

            number = `${number.slice(0, 3)}-${number.slice(3)}`;

            return (`(${city}) ${number}`).trim();
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/filters/phone.js